import * as z from "zod";
import { zodSortField } from "../utils";

const baseImmatriculationCodeRejetRecyclAutoSchema = z.object({
  operationType: z
    .string()
    .min(3)
    .max(3)
    .regex(/^[A-Z]{3}$/, "3 lettres majuscules obligatoires"),

  rejectCode: z
    .string()
    .min(3)
    .max(3)
    .regex(/^[0-9]{3}$/, "3 chiffres obligatoires"),

  startDate: z.coerce.date(),

  endDate: z.coerce.date().optional().nullable(),

  isActive: z.boolean(),
});

export const addImmatriculationCodeRejetRecyclAutoSchema =
  baseImmatriculationCodeRejetRecyclAutoSchema.refine(
    (data) => !data.endDate || data.endDate > data.startDate,
    {
      message: "La date de fin doit être supérieure à la date de début",
      path: ["endDate"],
    },
  );

export const editImmatriculationCodeRejetRecyclAutoSchema =
  baseImmatriculationCodeRejetRecyclAutoSchema
    .extend({
      id: z.number(),
    })
    .refine((data) => !data.endDate || data.endDate > data.startDate, {
      message: "La date de fin doit être supérieure à la date de début",
      path: ["endDate"],
    });

export const deleteImmatriculationCodeRejetRecyclAutoSchema = z.object({
  id: z.number(),
});

export const getImmatriculationCodeRejetRecyclAutoRequestSchema = z.object({
  sort: zodSortField(["operationType", "rejectCode", "startDate", "endDate"]),
});
